import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Split} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronLeftLine, ChevronRightLine, ClockLine} from '@dropbox/dig-icons/assets';
import {t} from 'i18next';

/** Month prev/next tabs and optional jump-to-upcoming control for the calendar tile header. */
export const CalendarMonthNav = ({
  onPrevMonth,
  onNextMonth,
  onJumpToUpcoming,
}: {
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onJumpToUpcoming?: () => void;
}) => (
  <Split alignY="center" gap="4">
    {onJumpToUpcoming ? (
      <Split.Item>
        <Tooltip title={t('dashboard_jump_to_upcoming').toString()}>
          <IconButton
            variant="borderless"
            size="small"
            onClick={onJumpToUpcoming}
            aria-label={t('dashboard_jump_to_upcoming').toString()}
          >
            <UIIcon src={ClockLine} size="small" />
          </IconButton>
        </Tooltip>
      </Split.Item>
    ) : null}
    <Split.Item>
      <IconButton
        variant="borderless"
        size="small"
        onClick={onPrevMonth}
        aria-label={t('dashboard_previous_month').toString()}
      >
        <UIIcon src={ChevronLeftLine} size="small" />
      </IconButton>
    </Split.Item>
    <Split.Item>
      <IconButton
        variant="borderless"
        size="small"
        onClick={onNextMonth}
        aria-label={t('dashboard_next_month').toString()}
      >
        <UIIcon src={ChevronRightLine} size="small" />
      </IconButton>
    </Split.Item>
  </Split>
);
